// components/ArticleList.tsx
import React, { } from 'react';
import { Card } from '@mui/material';
import { TFunction } from 'next-i18next';
import ImageRound from '../../ImageRound';
import { black, white } from '@/constants/Colors';
import { obtenerImagenes, obtenerURLLibroByCategoriaIdArticle } from '@/util/Articulos';
import Texto from '../../Texto';
import { GetLibroFavorito } from '@/objects/Articles';
import FavoriteIcon from '@mui/icons-material/Favorite';

interface Props {
  t: TFunction;
  notificacionGetLibroFavorito: GetLibroFavorito;
}

const RowNotificacionesFavoritos: React.FC<Props> = ({ t, notificacionGetLibroFavorito }) => {
  //alert("Renderizando RowNotificacionesFavoritos con libro: " + notificacionGetLibroFavorito.articulo_categoria);

  function abrirLibro() {
    window.open(obtenerURLLibroByCategoriaIdArticle(notificacionGetLibroFavorito.articulo_categoria, notificacionGetLibroFavorito.id_article), '_blank');
  }

  return (
    <Card onClick={() => { abrirLibro() }}
      style={{
        cursor: "pointer", display: 'flex', flexDirection: 'row',
        alignItems: 'center', justifyContent: 'space-between', width:
          window.innerWidth < 500 ? "94%" : "450px",
        backgroundColor: white,
        color: black,
        padding: "20px",
      }}>
      <article style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: "100%" }}>
        <section style={{ position: 'relative', width: '20%' }}>
          <ImageRound
            src={obtenerImagenes(notificacionGetLibroFavorito.image, "").image_preview}
            alt={t("menu:secciones.mensajes.imagen_articulo" + notificacionGetLibroFavorito.title)}
            width={70}
            height={70}
          />
        </section>
        <section style={{ display: 'flex', flexDirection: 'column', marginLeft: "10px", width: '52%' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
            <FavoriteIcon style={{ color: "#e25555", fontSize: "20px", marginBottom: "4px" }} />
            <Texto color={black} fontWeight='600'>{t("menu:secciones.mensajes.a_alguien_le_gusta_tu_libro")}</Texto>
          </div>
          <Texto color={black}>{t("menu:secciones.mensajes.ha_sido_add_favorito", { titulo: notificacionGetLibroFavorito.title })}</Texto>
          {/* <Texto color={black} fontSize={textosMini}>{dateToText(notificacionGetLibroFavorito.fecha_mod, t) + " " + obtenerHora(notificacionGetLibroFavorito.fecha)}</Texto> */}
        </section>
      </article>
    </Card>
  );
};

export default RowNotificacionesFavoritos;
